export default "__VITE_ASSET__d1fda320__"